import { ObjectMapper } from "json-object-mapper";
import { IModel } from "./IModel";
import { Model } from "./model";

export class FeatureFlagModel extends Model implements IModel<FeatureFlagModel> {
  showCardPeople: boolean = false;
  jobTitleManagement: boolean = false;
  costCenterManagement: boolean = false;
  timeShiftManagement: boolean = false;
  hourlyBasisLimitDate: boolean = false;
  hasExcusedAbsences: boolean = false;
  usesPerformanceReview: boolean = false;
  usesEmployeeFeedbacks: boolean = false;
  usesInfringements: boolean = false;
  usesJobEngineer: boolean = false;
  usesHiringAdditionalDocuments: boolean = false;
  usesComptimeEmployeeBalance: boolean = false;

  static create(input: any): FeatureFlagModel {
    return ObjectMapper.deserialize<FeatureFlagModel>(FeatureFlagModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  public hasEnabled(flagName: string): boolean {
    return flagName in this && (this as any)[flagName] === true;
  }
}
